import {
  SHOW_NEW_INTERVENTIONS_LOADER,
  SHOW_NEW_INTERVENTIONS_MESSAGE,
  FETCH_NEW_INTERVENTIONS_DOCTORS,
  FETCH_NEW_INTERVENTIONS_DOCTORS_SUCCESS,
  ON_SAVE_INTERVENTIONS,
  SHOW_NEW_INTERVENTIONS_SAVE_LOADER,
  HIDE_NEW_INTERVENTIONS_MESSAGE
} from 'constants/ActionTypes';

export const showNewInterventionsLoader = () => {
  return {
    type: SHOW_NEW_INTERVENTIONS_LOADER
  };
};
export const showNewInterventionsMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_NEW_INTERVENTIONS_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const fetchDoctors = () => {
  return {
    type: FETCH_NEW_INTERVENTIONS_DOCTORS
  }
}
export const fetchDoctorsSuccess = (data) => {
  return {
    type: FETCH_NEW_INTERVENTIONS_DOCTORS_SUCCESS,
    payload: data
  };
}
export const onSaveNewInterventions = (data) => {
  return {
    type: ON_SAVE_INTERVENTIONS,
    payload: data
  };
}
export const showNewInterventionsSaveLoader = () => {
  return {
    type: SHOW_NEW_INTERVENTIONS_SAVE_LOADER
  };
}
export const hideNewInterventionsMessage = () => {
  return {
    type: HIDE_NEW_INTERVENTIONS_MESSAGE
  };
}



// WEBPACK FOOTER //
// ./actions/NewInterventions.js